import easydropdown from 'easydropdown';
import slick from 'slick-carousel';
import magnificPopup from 'magnific-popup';

const setupNewsSearch = () => {
    let currentPage = 1;
    const PAGE_LENGTH = 8;
    const $search = $('.news-search');
    const $category = $('.news-search--category select');
    const $dateForm = $('.news-search--date');
    const $dateYear = $('select[name=date_year]');
    const $dateMonth = $('select[name=date_month]');
    const $newsPagination = $('.newsroom-pagination');
    const $newsPaginationMore = $('.newsroom-pagination__more');
    const $newsPaginationLess = $('.newsroom-pagination__less');
    const $newsList = $('.newsroom-list');

    if (!$search.length) {
        return;
    }

    $('.styled-dropdown select').each((_, el) => {
        if (!el.querySelector('[selected]')) {
            el.selectedIndex = -1;
        }
    });

    const handleDateForm = () => {
        const selectedYear = $dateYear.val();
        const selectedMonth = $dateMonth.data('selected');

        if (selectedYear) {
            const months = $dateYear.data('months')[selectedYear];

            let newOptions = '<option data-placeholder>Month</option>';

            for (const monthNum of Object.keys(months)) {
                const selected = selectedMonth == monthNum ? 'selected' : '';
                const monthName = months[monthNum];
                newOptions += `<option value="${monthNum}" ${selected}>${monthName}</option>`;
            }

            $dateMonth.html(newOptions);
            $dateMonth.prop('disabled', false);
        }
    };

    easydropdown($category[0], {
        callbacks: {
            onSelect: value => (window.location.href = value),
        },
    });

    easydropdown($dateYear[0], {
        callbacks: {
            onSelect: () => {
                $dateForm.submit();
            },
        },
    });

    easydropdown($dateMonth[0], {
        behavior: {
            liveUpdates: true,
        },
        callbacks: {
            onSelect: () => {
                $dateForm.submit();
            },
        },
    });

    handleDateForm();

    $dateForm.on('submit', e => {
        e.preventDefault();

        const selectedYear = $dateYear.val() ? $dateYear.val() : '';
        const selectedMonth = $dateMonth.val() ? $dateMonth.val() : '';
        const formUrl = $dateForm.prop('action');

        const url = `${formUrl}/${selectedYear}/${selectedMonth}`;

        window.location.href = url;
    });

    const handleNewsPagination = () => {
        const total = $newsList.find('li').length;
        const hiddenIndex = currentPage * PAGE_LENGTH;

        if (total > PAGE_LENGTH) {
            $newsList.find('li').each((index, el) => {
                $(el).toggleClass('is-hidden', index >= hiddenIndex);
            });
        }

        const currentCount = $newsList.find('li').not('.is-hidden').length;

        $newsPagination
            .find('.newsroom-pagination__current')
            .text(currentCount);
        $newsPagination
            .find('.newsroom-pagination__actions')
            .toggle(total > PAGE_LENGTH);
        $newsPaginationMore.toggle($newsList.find('li.is-hidden').length > 0);
        $newsPaginationLess.toggle(currentPage > 1);
    };

    handleNewsPagination();

    $newsPaginationMore.on('click', () => {
        currentPage = currentPage + 1;
        handleNewsPagination();
    });

    $newsPaginationLess.on('click', () => {
        currentPage = 1;
        handleNewsPagination();
        $.scrollTo(document.body, 200);
    });
};

const setupNewsSubscribe = () => {
    const $trigger = $('[data-subscribe-trigger]');

    if (!$trigger.length) {
        return;
    }

    $trigger.magnificPopup({
        mainClass: 'mfp-fade js-modal-form',
        type: 'ajax',
        fixedContentPos: true,
        closeOnBgClick: false,
        callbacks: {
            ajaxContentAdded: () => {
                const $form = $('.news-subscribe-form');
                const $email = $form.find('input[type=email]');

                $form.on('submit', e => {
                    e.preventDefault();

                    if ($.trim($email.val()) !== '') {
                        $.ajax({
                            type: 'post',
                            dataType: 'json',
                            url: $form.prop('action'),
                            data: $form.serialize(),
                            beforeSend: function() {
                                $form.find('.message').hide();
                                $form
                                    .find('input[type=submit]')
                                    .prop('disabled', true);
                            },
                            success: function(resp) {
                                if (resp.success) {
                                    $form.find('.success').show();
                                    $form
                                        .find('input[type=email]')
                                        .val('')
                                        .blur();

                                    setTimeout(() => {
                                        $form.find('.success').fadeOut();
                                    }, 3000);
                                } else {
                                    if (resp.message == 'duplicate') {
                                        $form.find('.duplicate').show();
                                    }
                                }
                            },
                            complete: function() {
                                $form
                                    .find('input[type=submit]')
                                    .prop('disabled', false);
                            },
                        });
                    } else {
                        $email.focus();
                        $form.find('.empty').show();
                    }
                });
            },
        },
    });
};

const setupNewsSlider = () => {
  if ($('.newsroom-media-slider').children().length > 1) {
    $('.newsroom-media-slider').slick({
      dots: true,
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
    })
  }
}

const setupVideoPopups = () => {
    const $popups = $('.js-video-popup')

    if (!$popups.length) {
      return
    }

    $(document).magnificPopup({
      delegate: '.js-video-popup',
      type: 'iframe',
      closeOnBgClick: false,
      iframe: {
        markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen title="Youtube Video"></iframe>' +
        '</div>',
        patterns: {
          youtube: {
            src:
            '//www.youtube.com/embed/%id%?autoplay=1',
          },
        },
      },
    })

    $('body').on('click', '.js-video-popup', e => {
      e.preventDefault()
    })
  }

export default {
    can: () =>
        $('body').hasClass('pagetype-blog') ||
        $('body').hasClass('pagetype-blogpost'),
    run: () => {
        setupNewsSearch();
        setupNewsSubscribe();
        setupNewsSlider();
        setupVideoPopups();
    },
};
